import {
    AlgoliaAnalyticsEventAction,
    type AlgoliaAnalyticsEventName,
    AlgoliaAnalyticsEventPage,
    AlgoliaAnalyticsEventSource,
} from '@jsmdg/tracking';
import { PageType } from '../../shared/enums/pageType';

const algoliaAnalyticsEventPageMap: Partial<Record<PageType, AlgoliaAnalyticsEventPage>> = {
    [PageType.Product]: AlgoliaAnalyticsEventPage.ProductDetailPage,
};

export function getAlgoliaAnalyticsRecommendationClickedEventName(
    pageType?: PageType,
): AlgoliaAnalyticsEventName | undefined {
    const eventPage = pageType ? algoliaAnalyticsEventPageMap[pageType] : undefined;

    if (!eventPage) return undefined;

    return {
        page: eventPage,
        source: AlgoliaAnalyticsEventSource.Recommendations,
        action: AlgoliaAnalyticsEventAction.ProductClicked,
    };
}
